<template>
  <div class="main">
    <van-nav-bar
      title="注销账户"
      left-text=""
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="content">
      <div class="risk" v-if="riskFlag">
        <p class="rist_title">注销账户存在以下风险</p>
        <div class="risk_boxs">
          <div class="risk_main">
            <!-- <div class="rist_circle"></div> -->
            <p>1、账号注销后，信息不能找回，请谨慎操作</p>
            <!-- <div class="clear"></div> -->
          </div>
          <div class="risk_main">
            <!-- <div class="rist_circle"></div> -->
            <p>
              2、清空迪夫康复平台所有信息，包括但不限于个人资料等所有存贮的信息
            </p>
            <!-- <div class="clear"></div> -->
          </div>
          <div class="risk_bot">
            <!-- <img :src="riskImg" class="riskImg" /> -->
            <p>*以上信息均将被删除，不可恢复</p>
          </div>
        </div>
      </div>
      <div class="cancelCode" v-if="!riskFlag">
        <div class="cancelCode_title">我们将会向您注册手机号发送验证码</div>
        <van-form>
          <van-field
            v-model="smsCode"
            name="smsCode"
            center
            clearable
            label=""
            type="number"
            placeholder="请输入验证码"
            class="smsCode-input"
            maxlength="6"
            @input="getFieldValue"
          >
            <template #button>
              <input
                readonly
                class="push-btn"
                @click="sendCode"
                :disabled="btnStatus"
                :value="
                  verifyCode == '获取验证码' ? verifyCode : verifyCode + 's'
                "
              />
            </template>
          </van-field>
        </van-form>
      </div>
      <div class="cancelBtn_box">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          @click="submit"
          class="cancelBtn"
        >
          {{ btnTect }}
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { encryptBy, decryptBy } from "@/assets/js/encryption";
import { _getCode } from "../../api/login";
import { _cancel } from "../../api/setting";
import { Dialog } from "vant";
import Cookies from "js-cookie";
export default {
  name: "cancel",
  data() {
    return {
      riskImg: require("./../../assets/images/setting/rist.png"),
      btnTect: "申请注销账户",
      riskFlag: true,
      smsCode: "",
      btnStatus: false,
      verifyCode: "获取验证码",
      phoneNumber: "",
    };
  },
  created() {
    let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    this.phoneNumber = decryptBy(user.mobilePhone);
  },
  methods: {
    //返回
    onClickLeft() {
      if (this.riskFlag) {
        history.go(-1);
      } else {
        this.riskFlag = true;
        this.btnTect = "申请注销账户";
      }
    },
    //提交注销
    submit() {
      this.riskFlag = false;
      if (this.btnTect == "注销") {
        if (this.smsCode == "") {
          this.$toast("请填写验证码");
        } else {
          let data = {
            code: this.smsCode,
            origin: "C",
            phone: encryptBy(this.phoneNumber),
          };
          Dialog.confirm({
            title: "你确定要注销账户吗？",
            message: "",
          })
            .then(() => {
              _cancel(data).then((res) => {
                if (res.code == 200) {
                  this.$toast("您已成功注销账户");
                  Cookies.remove("token");
                  localStorage.removeItem("childId");
                  localStorage.removeItem("children");
                  setTimeout(() => {
                    this.$router.push("/login");
                  }, 1000);
                } else {
                  this.$toast(res.message);
                }
              });
            })
            .catch(() => {});
        }
      }
      this.btnTect = "注销";
    },
    //获取验证码
    sendCode() {
      let data = {
        origin: "C",
        phone: encryptBy(this.phoneNumber),
        type: 1,
      };
      this.smsCode = "";
      _getCode(data).then((res) => {
        if (res.code == 200) {
          this.verifyCode = 120;
          this.btnStatus = true;
          this.timer = setInterval(() => {
            if (this.verifyCode > 0 && this.verifyCode <= 120) {
              this.verifyCode = this.verifyCode - 1;
            } else {
              clearInterval(this.timer);
              this.verifyCode = "获取验证码";
              this.btnStatus = false;
            }
          }, 1000);
        } else {
          this.$toast(res.message);
        }
      });
    },
    getFieldValue(e) {
      this.smsCode = e;
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  position: relative;
  height: 100%;
  background: #f5f7fa url(../../assets/images/setting/bg.png) no-repeat left
    top/100% 311px;
}
.content {
  background: #fff;
  margin: 8px 20px 0;
  padding-bottom: 30px;
}
.risk {
  .rist_title {
    width: 100%;
    text-align: center;

    // font-weight: 500;
    // color: #ffa070;
    padding-top: 20px;
    margin-bottom: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2e4344;
  }
  .risk_boxs {
    margin: 0 auto;
    width: 315px;
    height: auto;
    // padding: 18px 0;
    // background: #faf9fd;
    border-radius: 6px;
    .risk_main {
      margin-bottom: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2e4344;
      .rist_circle {
        width: 8px;
        height: 8px;
        background: #ffa070;
        border-radius: 50%;
        margin-left: 20px;
        margin-right: 6px;
        // float: left;
        margin-top: 6px;
      }
      p {
        // width: 254px;
        margin-right: 20px;
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        // float: left;
      }
      //   .clear {
      //     clear: both;
      //   }
    }
    .risk_bot {
      margin: 10px 0;
      //   display: flex;
      //   justify-content: center;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ee3721;
      //   .riskImg {
      //     width: 13px;
      //     height: 13px;
      //     margin-right: 10px;
      //     margin-top: 3px;
      //   }
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff453b;
      }
    }
  }
}
.cancelCode {
  width: 90%;
  padding-top: 23px;
  margin-left: 5%;
  .cancelCode_title {
    width: 100%;
    text-align: center;
    // font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
    // font-weight: 400;
    // color: #111111;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2e4344;
    // margin: 30px 0;
    margin-bottom: 30px;
  }
  .smsCode-input {
    // border-top: solid 1px #eaeaea;
    // border-bottom: solid 1px #eaeaea;
    width: 295px;
    height: 44px;
    background: #f3f6f7;
    box-shadow: 0px 2px 4px 0px rgba(243, 246, 247, 0.3);
    border-radius: 4px;
    .push-btn {
      width: 110px;
      //   height: 25px;
      // background: #F4F2FF;
      //   border-radius: 13px;
      //   border: 1px solid #ffa070;
      text-align: right;
      //   color: #ffa070;
      //   line-height: 25px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #00aadf;
      background: transparent;
    }
  }
}
.cancelBtn_box {
  text-align: center;
  //   position: absolute;
  //   bottom: 58px;
  margin-top: 280px;
  width: 100%;
  .cancelBtn {
    // background: linear-gradient(180deg, #C7B3FF 0%, #8B6FFC 100%);
    // background: #ffa070;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border: none;
    width: 266px;
    height: 38px;
    margin: 0 auto;
  }
}
</style>
